import { ImageLoader } from '../../../ImageLoader';
import { useLocale } from '../../../../i18n/locale';
import { getImageAssetWithLocale, imageKeys } from './imageAssets';
import { ChapterHeadline } from '../chapterComponents/ChapterHeadline';
import { ChapterText } from '../chapterComponents/ChapterText';
import { TranslationsKeys, useCustomIntl } from '../../../../i18n/i18n';
import { ChapterSubHeadline } from '../chapterComponents/ChapterSubHeadline';

type ParkingImage = {
  image: string;
  alt: TranslationsKeys;
};

export const ServicesParkingChapter = () => {
  const { locale } = useLocale();
  const { formatMessage } = useCustomIntl();

  const headlineImage = getImageAssetWithLocale(
    imageKeys.servicesParking1,
    locale,
  );

  const driverAppImages: ParkingImage[] = [
    {
      image: getImageAssetWithLocale(imageKeys.servicesParking3, locale),
      alt: 'userManual.chapter.services.parking.image3Alt',
    },
    {
      image: getImageAssetWithLocale(imageKeys.servicesParking4, locale),
      alt: 'userManual.chapter.services.parking.image4Alt',
    },
    {
      image: getImageAssetWithLocale(imageKeys.servicesParking5, locale),
      alt: 'userManual.chapter.services.parking.image5Alt',
    },
    {
      image: getImageAssetWithLocale(imageKeys.servicesParking6, locale),
      alt: 'userManual.chapter.services.parking.image6Alt',
    },
  ];

  const appQRCodeImages: ParkingImage[] = [
    {
      image: getImageAssetWithLocale(imageKeys.manPlayStoreQr, locale),
      alt: 'userManual.googleplayQRCodeImageAlt',
    },
    {
      image: getImageAssetWithLocale(imageKeys.manAppleStoreQr, locale),
      alt: 'userManual.appstoreQRCodeImageAlt',
    },
  ];

  const appButtonImages: ParkingImage[] = [
    {
      image: getImageAssetWithLocale(imageKeys.playStore, locale),
      alt: 'userManual.googleplayImageAlt',
    },
    {
      image: getImageAssetWithLocale(imageKeys.appStore, locale),
      alt: 'userManual.appstoreImageAlt',
    },
  ];

  return (
    <div>
      <div className={'row col-xs-12'}>
        <ChapterHeadline
          messageId={'userManual.chapter.services.parking.headline'}
        />
        <div
          className={
            'display-flex col-xs-12 gap-25 flex-column flex-row-md padding-0'
          }
        >
          <ChapterText
            colSize={12}
            colSizeMd={6}
            messageId={'userManual.chapter.services.parking.text'}
          />
          <div className="col-xs-12 col-md-6 margin-bottom-25">
            <ImageLoader
              src={headlineImage}
              className={'border'}
              alt={formatMessage({
                id: 'userManual.chapter.services.parking.headline',
              })}
              enlargeable
            />
          </div>
        </div>
      </div>
      <div className={'row margin-top-20'}>
        <ChapterSubHeadline
          messageId={'userManual.chapter.services.parking.section1.title'}
        />
        <div
          className={
            'col-xs-12 display-flex gap-25 flex-column flex-row-md padding-0'
          }
        >
          <ChapterText
            messageId={'userManual.chapter.services.parking.section1.text'}
            className={'col-xs-12'}
          />
          <div className={'col-xs-12 display-flex gap-10'}>
            <ImageLoader
              className="border"
              src={getImageAssetWithLocale(imageKeys.servicesParking2, locale)}
              alt={formatMessage({
                id: 'userManual.chapter.services.parking.section1.title',
              })}
              enlargeable
            />
          </div>
        </div>
      </div>
      <div className={'row margin-top-20'}>
        <ChapterSubHeadline
          messageId={'userManual.chapter.services.parking.section2.title'}
        />
        <div
          className={
            'col-xs-12 display-flex gap-25 flex-column flex-row-md padding-0'
          }
        >
          <ChapterText
            messageId={'userManual.chapter.services.parking.section2.text'}
            className={'col-xs-12'}
          />
          <div className={'col-xs-12'}>
            <div className="display-flex gap-10">
              {driverAppImages.map(({ image, alt }) => {
                return (
                  <div
                    key={alt}
                    className={'col-xs-3 padding-0'}
                  >
                    <ImageLoader
                      className="border"
                      src={image}
                      alt={formatMessage({ id: alt })}
                      enlargeable
                    />
                  </div>
                );
              })}
            </div>
            <div className="display-flex gap-10 margin-top-20">
              {appQRCodeImages.map(({ image, alt }) => {
                return (
                  <div
                    key={alt}
                    className={'col-xs-3 padding-0'}
                  >
                    <ImageLoader
                      className="border"
                      src={image}
                      alt={formatMessage({ id: alt })}
                      enlargeable
                    />
                  </div>
                );
              })}
            </div>
            <div className="display-flex gap-10 margin-top-10">
              {appButtonImages.map(({ image, alt }) => {
                return (
                  <div
                    key={alt}
                    className={'col-xs-3 padding-0'}
                  >
                    <ImageLoader
                      src={image}
                      alt={formatMessage({ id: alt })}
                      enlargeable
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
